import { render, staticRenderFns } from "./web-content-page-listing.vue?vue&type=template&id=470da6e4&scoped=true&"
import script from "./web-content-page-listing.vue?vue&type=script&lang=js&"
export * from "./web-content-page-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470da6e4",
  null
  
)

export default component.exports